rdefine('app/events/event-time-row', ['backbone','text!events/time-row.html'], function(Backbone, template) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'events-time-row',
        bindings:{
            span:{
                text: {
                    data: ['model.from', 'model.end'],
                    processor: function (from, to) {
                        var fh = Math.floor(from / 100);
                        var fm = from % 100;
                        var th = Math.floor(to / 100);
                        var tm = to % 100;
                        if(fh === th && tm === fm) {
                            return moment().hour(fh).minute(tm).format("HH:mm");
                        }
                        return moment().hour(fh).minute(fm).format("HH:mm") + " - " + moment().hour(th).minute(tm).format("HH:mm");
                    }
                }
            },
            '.iedit':{
                toggle:'state.edit'
            },
            '.itsrow':{
                classes:{
                    ishow: {
                        data: 'state.edit',
                        processor: function (a) {
                            return !a;
                        }
                    }
                }
            },
            '.start-time-add input':{
                value:'state.edits'
            },
            '.end-time-add input':{
                value:'state.edite'
            },
            '.doUpdateTime':{
                enabled:'state.canupdate'
            }
        },
        events:{
            "click .itsrow .btn":"onDelete",
            'focus input':'onFocus',
            'blur input':'onBlur',
            'click .itsrow div':'onEditClick',
            'click .cancelEditTime':'cancelEditTime',
            'click .doUpdateTime':'doUpdateTime'
        },
        initialize:function() {
            this.state = new Backbone.Ribs.Model({edit:false, edits:'',edite:'',canupdate:false});
            this.state.on("change:edits change:edite", _.bind(this.onStateDateChange,this));
            this.model.on("change:from change:end",_.bind(this.setFromModel,this));
            this.setFromModel();
            this.$el.html(Template7.compile(template)());
            this.$el.find("input.time-row").mask("00:00",{selectOnFocus:true,onComplete:this.onAddComplete.bind(this)}).blur();
        },
        onDelete: function() {
            this.collection.trigger('time-remove',this.model);
        },
        onAddComplete:function(e){

        },
        onFocus:function(e) {
            var t= $(e.target);
            t.attr("placeholder","xx:xx");
        },
        onBlur:function(e) {
            var t= $(e.target);
            t.attr("placeholder",t.attr("placeholder-ex"));
            if(t.val().length<5) {
                t.val("");
            }
        },
        onEditClick:function() {
            this.state.set('edit',true);
        },
        onStateDateChange: function() {
            var s = this.state.get('edits','00:00') || '00:00';
            s = s.split(":");
            if(s[1]>59) {
                s[1] = 59;
                this.state.set('edits',s[0]+":59");
            }
            s = s[0]*100 + +s[1];
            var e = this.state.get('edite') || '00:00';
            e = e.split(":");
            if(e[1]>59) {
                e[1] = 59;
                this.state.set('edite',e[0]+":59");
            }
            e = e[0]*100 + +e[1];
            if(s<0) {
                this.state.set('edits','00:00');
            }
            if(e<0) {
                this.state.set('edite','00:00');
            }
            if(s>2359) {
                this.state.set('edits','23:59');
            }
            if(e>2359) {
                this.state.set('edite','23:59');
            }

            if(e<s) {
                this.state.set('edite',this.state.get('edits'));
            }

            var from = this.model.get("from");
            var end = this.model.get("end");
            var ta = moment().hour(Math.floor(from/100)).minute(from%100).format("HH:mm");
            var tb = moment().hour(Math.floor(end/100)).minute(end%100).format("HH:mm");
            if(ta!==this.state.get('edits') || tb !==this.state.get('edite')) {
                this.state.set('canupdate',true);
            }else{
                this.state.set('canupdate',false);
            }

        },
        setFromModel:function() {
            var from = this.model.get("from");
            var end = this.model.get("end");
            this.state.set({
                edits: moment().hour(Math.floor(from/100)).minute(from%100).format("HH:mm"),
                edite: moment().hour(Math.floor(end/100)).minute(end%100).format("HH:mm")
            });
        },
        cancelEditTime: function() {
            this.setFromModel();
            this.state.set('edit',false);
        },
        doUpdateTime: function() {
            var s = this.state.get('edits','00:00') || '00:00';
            var st = s.split(":");
            if(st[1]>59) {
                st[1] = 59;
            }
            st = st[0]*100 + +st[1];
            var e = this.state.get('edite') || '00:00';
            var et = e.split(":");
            if(et[1]>59) {
                et[1]=59;
            }
            et = et[0]*100 + +et[1];
            this.collection.trigger('time-update',this.model.attributes,{from:st,end:et});
            this.state.set('edit',false);
            this.model.set({from:st,end:et});



        }
    });
});